<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-age.mr-2(ref="age" :filter.sync="ageFilter" check-initial-value)
    filter-urgency.mr-2(ref="urgency" :filter.sync="urgencyFilter" check-initial-value)
    filter-date.mr-2(ref="arrived" :filter.sync="dateFilter" title="Arrived date" check-initial-value)
    filter-provider.mr-2(ref="provider" :filter.sync="providerFilter" check-initial-value)
    filter-payment.mr-2(ref="payment" :filter.sync="paymentFilter" check-initial-value)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterAge from '@/components/module/filter/FilterAge.vue'
import FilterUrgency from '@/components/module/filter/FilterUrgency.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterProvider from '@/components/module/filter/FilterProvider.vue'
// import FilterPayment from '@/components/module/filter/FilterPayment.vue'
import FilterPayment from '@/components/module/filter/FilterPanelPayment.vue'

export default {
  name: 'FilterRow',
  components: { FilterName, FilterAge, FilterUrgency, FilterDate, FilterProvider, FilterPayment },
  props: ['filters', 'propFilters'],
  data: () => ({
    nameFilter: {},
    ageFilter: {},
    urgencyFilter: {},
    dateFilter: {},
    providerFilter: {},
    paymentFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.ageFilter.key) {
        if (this.ageFilter.key === 'between') {
          const values = this.ageFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.ageFilter)
        }
      }
      if (this.urgencyFilter.key) {
        filters.push(this.urgencyFilter)
      }
      if (this.dateFilter.key) {
        if (this.dateFilter.key === 'between') {
          const values = this.dateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dateFilter)
        }
      }
      if (this.providerFilter.key) {
        filters.push(this.providerFilter)
      }
      if (this.paymentFilter.key) {
        filters.push(this.paymentFilter)
      }
      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        ageFilter: this.ageFilter,
        urgencyFilter: this.urgencyFilter,
        dateFilter: this.dateFilter,
        providerFilter: this.providerFilter,
        paymentFilter: this.paymentFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.ageFilter = this.propFilters?.ageFilter || {}
      this.urgencyFilter = this.propFilters?.urgencyFilter || {}
      this.dateFilter = this.propFilters?.dateFilter || {}
      this.providerFilter = this.propFilters?.providerFilter || {}
      this.paymentFilter = this.propFilters?.paymentFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.age.setData()
        this.$refs.urgency.setData()
        this.$refs.arrived.setData()
        this.$refs.provider.setData()
        this.$refs.payment.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.ageFilter = {}
      this.urgencyFilter = {}
      this.dateFilter = {}
      this.providerFilter = {}
      this.paymentFilter = {}
    }
  }
}
</script>